<template>
  <div>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>密友会管理</el-breadcrumb-item>
    </el-breadcrumb> -->

    <el-card>
      <el-row class="title_row">
        <el-col>
          <span class="title_class">密友会管理</span>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col
          v-for="(item, i) in myhToolList"
          :key="i"
          :span="6"
          style="margin-top: 30px"
        >
          <div class="racing-tool-back" @click="myhToolClicked(item)">
            <div class="racing-tool-leftimg" :class="'coloricon' + item.menuTag">
              <i class="icon iconfont" :class="item.icon"></i>
            </div>
            <div class="racing-tool-right">
              <div>{{ item.rightTitle }}</div>
              <div class="racing-tool-desc">{{ item.rightDesc }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'MyhManagement',
  data () {
    return {
      myhToolList: [
        {
          rightTitle: '密友会列表',
          rightDesc: '查看并管理密友会分会信息',
          icon: 'icon-huiyuanjulebu',
          menuTag: '1',
          turnUrl: '/myh_management/myh_list'
        },
        {
          rightTitle: '会员审核',
          rightDesc: '查看并处理会员审核申请',
          icon: 'icon-shenhetongguo',
          menuTag: '2',
          turnUrl: '/myh_management/myh_member_audit'
        }
      ]
    }
  },
  methods: {
    myhToolClicked (item) {
      if (!item.turnUrl) return
      this.$router.push(item.turnUrl)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
